
document.addEventListener('DOMContentLoaded', () => {

  const listThumbnails = document.querySelectorAll(`[data-thumbnail-modal-id]`);

  for (let i = 0; i < listThumbnails.length; i++) {
    const thumbnails = listThumbnails[i];
    const swiperTriggers = document.querySelectorAll(`.js-modal-trigger[data-thumbnail-id="${thumbnails.dataset.thumbnailModalId}"]`);
    const closeModaltrigger = document.querySelectorAll('.js-close-modal')

    this.setActiveElement(thumbnails);

    this.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.closeThumbnailsModal();
    });

    const thumbs = new Swiper('.myThumbs', {
      loop: true,
      spaceBetween: 5,
      slidesPerView: 4,
      watchSlidesProgress: true,
    });

    const swiper = new Swiper('.mySwiper', {
      loop: false,
      slidesPerView: 1,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: thumbs,
      },
    });

    swiperTriggers.forEach((e) => {
      e.addEventListener(('click'), () => {
        
        const itemIndex = Number(e.dataset.index)
        console.log(itemIndex, "itemIndex");
        
        thumbnails.classList.add('active')
        swiper.slideTo(itemIndex)
        document.body.style.overflowY = 'hidden';
      })
    })

    closeModaltrigger.forEach((e) => {
      e.addEventListener(('click'), () => {
        thumbnails.classList.add('closing');
        document.body.style.overflowY = 'auto';
        setTimeout(() => {
          thumbnails.classList.remove('active');
          thumbnails.classList.remove('closing');
          removeTrapFocus(thumbnails);
        }, 500);
      })
    })
  }
});

